import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { Sparkles, HeartHandshake, Sun } from "lucide-react";

const icons = [Sparkles, HeartHandshake, Sun];

const Pranic = () => {
  const { t } = useLanguage();
  const r = useReveal();

  return (
    <section id="pranic" className="py-16 sm:py-24 md:py-32 bg-brand-cream">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <p className="text-xs tracking-[0.4em] uppercase text-brand-gold mb-5">
          {t.pranic.kicker}
        </p>
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-brand-plumDark mb-8 sm:mb-10 leading-tight">
          {t.pranic.title}
        </h2>
        <div className="space-y-5 text-left md:text-center max-w-3xl mx-auto">
          <p className="text-brand-ink/75 leading-relaxed">{t.pranic.p1}</p>
          <p className="text-brand-ink/75 leading-relaxed">{t.pranic.p2}</p>
          <p className="text-brand-ink/75 leading-relaxed">{t.pranic.p3}</p>
        </div>
      </div>

      <div ref={r.ref} className={`${r.className} max-w-6xl mx-auto px-6 mt-12 sm:mt-16 grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-7`}>
        {t.pranic.cards.map((card, i) => {
          const Icon = icons[i];
          return (
            <div
              key={i}
              className="group bg-white rounded-3xl p-8 shadow-[0_10px_40px_rgba(76,62,99,0.06)] border border-brand-sand hover:shadow-[0_20px_50px_rgba(76,62,99,0.12)] hover:-translate-y-1.5 transition-all duration-400"
            >
              <div className="w-14 h-14 rounded-2xl bg-brand-lavender/20 flex items-center justify-center mb-6 group-hover:bg-brand-gold/20 transition-colors">
                <Icon size={26} className="text-brand-plum" />
              </div>
              <h3 className="font-serif text-2xl text-brand-plumDark mb-3">{card.title}</h3>
              <p className="text-brand-ink/70 leading-relaxed">{card.text}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Pranic;
